import { Reveal, Eyebrow } from "./Reveal";

export default function About() {
  return (
    <section id="about" className="relative py-24 sm:py-36" data-testid="about-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-14 lg:grid-cols-2 lg:gap-20 lg:items-center">
          <Reveal className="relative order-2 lg:order-1">
            <div className="absolute -inset-3 rounded-3xl border border-[#FF5500]/30 translate-x-4 translate-y-4" />
            <img
              src="/assets/about-workshop.jpg"
              alt="Mobile One Audio workshop — custom motorcycle audio build in progress"
              className="relative aspect-[4/5] w-full rounded-3xl border border-white/10 object-cover"
            />
            <div className="absolute -bottom-6 -right-2 sm:right-6 rounded-2xl bg-[#FF5500] px-6 py-5 volt-glow">
              <p className="font-display text-2xl font-extrabold leading-none">Every vehicle</p>
              <p className="font-tech text-[10px] uppercase tracking-[0.25em] mt-1.5 text-white/85">
                treated like our own
              </p>
            </div>
          </Reveal>

          <div className="order-1 lg:order-2">
            <Reveal>
              <Eyebrow>About The Shop</Eyebrow>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
                Always been into
                <span className="block">cars <span className="text-[#FF5500]">&</span> sound.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-7 text-base sm:text-lg text-white/70 leading-relaxed">
                There's something different about driving a vehicle that feels dialed in —
                where the sound hits right, the details are clean, and everything looks
                intentional. What started as working on our own vehicles turned into people
                asking us to upgrade theirs. What we learned quickly? Most installs out
                there cut corners.
              </p>
              <p className="mt-4 text-base sm:text-lg text-white font-semibold">
                We don't.
              </p>
              <p className="mt-4 text-base text-white/70 leading-relaxed">
                Every install is done carefully, cleanly, and with pride. No rushed jobs.
                No sloppy wiring. No "that's good enough."
              </p>
            </Reveal>
            <Reveal delay={0.25}>
              <blockquote className="mt-10 border-l-2 border-[#FF5500] pl-6">
                <p className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-white">
                  "If we put our name on it,
                  <span className="text-[#FF5500]"> it's done right."</span>
                </p>
                <cite className="mt-3 block font-tech text-[10px] uppercase tracking-[0.3em] text-white/50 not-italic">
                  Mobile One Audio — New Castle, DE
                </cite>
              </blockquote>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
